import React, { JSX } from 'react';

import { DealType } from '~/src/dash/api/deals';
import { DealTypeToSticker } from '~/src/dash/components/filters/options/deals';
import { ICustomRenderCellJSXProps } from '~/src/dash/components/tables/ListViewTable/common';
import { useListViewTableStore } from '~/src/dash/components/tables/ListViewTable/context';
import { borderRadius, Div, Text, TooltipWithTranslation } from '~/src/dash/publicaUI';
import { headerBidderAdapterKeyToLabel } from '~/src/dash/utils/header-bidder-adapters';
import { TierIDToLabelMap } from '~/src/dash/utils/tiers';
import { useBaseStore } from '~/src/dash/views/base/contexts';

export enum ESelectedModal {
  TargetedChannels = 1,
  TargetedChannelGroups = 2,
}

export const DealTypeRender = (props: ICustomRenderCellJSXProps): JSX.Element => {
  const { color, backgroundColor, tKey, tooltipTKey } = DealTypeToSticker(props.value as DealType);
  return (
    <TooltipWithTranslation tKey={tooltipTKey}>
      <div>
        <Text
          singleLineLabel
          small
          disableSelect
          tKey={tKey}
          style={{
            display: 'inline-block',
            textAlign: 'center',
            padding: '12px',
            borderRadius: borderRadius.extraLarge,
            backgroundColor,
            color,
          }}
        />
      </div>
    </TooltipWithTranslation>
  );
};

export const DealTierRender = (props: ICustomRenderCellJSXProps): JSX.Element => {
  const { value } = props;
  return (
    <Text small bold>
      {TierIDToLabelMap[value as number]}
    </Text>
  );
};

export const DealPartnerRender = (props: ICustomRenderCellJSXProps): JSX.Element => {
  const { value } = props;
  const { session } = useBaseStore();
  return (
    <Text small bold>
      {headerBidderAdapterKeyToLabel(value as string, session.publisher)}
    </Text>
  );
};

export const DealChannelsListModalLink = (props: ICustomRenderCellJSXProps): JSX.Element => {
  const { customFunctions } = useListViewTableStore();
  const { value } = props;
  return (
    <Div
      onClick={() => customFunctions.handleClickOnChannelsList(props.row.ID.value)}
      style={{ cursor: 'pointer' }}
    >
      <Text small bold>
        {value}
      </Text>
    </Div>
  );
};

export const DealChannelGroupsListModalLink = (props: ICustomRenderCellJSXProps): JSX.Element => {
  const { customFunctions } = useListViewTableStore();
  const { value } = props;
  return (
    <Div
      onClick={() => customFunctions.handleClickOnChannelGroupsList(props.row.ID.value)}
      style={{ cursor: 'pointer' }}
    >
      <Text small bold>
        {value}
      </Text>
    </Div>
  );
};
